// Components
const Feeds = () => import(/* webpackChunkName: "social-club-feeds" */ '@/app/views/main-view/social-club/components/social-club-feeds/social-club-feeds.vue');

// Services
import PostService from '@/app/services/main/post/post-service';

// Constants
import { STATUS_CODES } from '@/app/constants/status-constants';

// Mixins
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';

export default {
    name: 'SocialClubDashboard',
    components: {
        Feeds
    },
    mixins: [toastMessageMixins],
    data() {
        return {
            feeds: {},
            index: 0,
            isAPILoading: true
        }
    },
    created() {
        this.getFeeds();
    },
    methods: {
        getFeeds() {
            PostService.getPosts({
                topic: 'general',
                groupId: 1001,
                offset: 0,
                limit: 5
            })
                .then(res => {
                    if (res.status === STATUS_CODES.SUCCESS) {
                       this.feeds = res.data.posts;
                       this.isAPILoading = false;
                    } else {
                        this.showAPIErrorToast('Unable to fetch product list.', res);
                        this.isAPILoading = false;
                    }
                });
        },
        moveFeed(direction) {
            if (direction === "right") { 
                this.index++;
            } else {
                this.index--;
            }

            if (this.index < 0) {
                this.index = this.feeds.length - 1;
            }

            if (this.index === this.feeds.length) {
                this.index = 0;
            }
        },
        showSocialClubPage() {
            this.$router.push('/social');
        }
    }
}